/**
 * Component Registry for Stonepost Ranch Apartment Homes
 * 
 * Inherits from @vibesites-price-brothers/theme-rise and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-rise/registry';
import { GallerySeparator } from './components/GallerySeparator';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import SisterProperties from './components/SisterProperties';
import { TabbedCallouts } from './components/TabbedCallouts';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  GallerySeparator,
  Header,
  Hero,
  SisterProperties,
  TabbedCallouts,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
